import React, {Suspense} from 'react';
import { History } from 'history';
import {Grid } from '@mui/material';
import { Media, ScreenGuard, Text } from '../../components';
import BasePreview from '../base/base-preview.component';
import Model from './report-model';  //editable..
import ApiService from '../../services/api.service';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    id?: number;
    caption?: string;
    proccessCaption?: string;
    save?: boolean;
    onLoadFile?: (data: any) => void;
    disableView?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowResult: any;
    isCompleted: boolean;
}

export default class ReportPreview extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowResult: null,
            isCompleted: false,
        }
        
    }

    private isMobile: boolean = AppService.isMobile();
    private isReady: boolean = false;
    private isCompleted: boolean = false;
    private htmlId =  'section';

    private onLoad = (data: any) => {
        this.setState({ datarow: data });
    }

    private onLoadResult = async(data: any) => {
        if (!this.isReady) {
            var optionText = JSON.stringify(this.state.datarow.option);
            data = {...data, reportname: this.state.datarow.name, reportdescription: this.state.datarow.name, documenttitle: document.title}
            optionText = AppService.replaceValue(optionText, data);
            this.setState({ datarow: {...this.state.datarow, option: JSON.parse(optionText)}});
            await this.setState({ datarowResult: data});
            this.isReady = true;
        }
    }

    private getContent(params: string, style?: any) {
        const paramsSplit = params.replace(/[<>]/gi,'').split(';');
        const url = paramsSplit[0];
        const section = paramsSplit[1];
        const Component = React.lazy(() => import(`../${url}.component`).catch(() => {return ({default: () => {}})} ));

        return (
            <Suspense>
                <Component history={this.props.history} onLoad={this.onLoadResult} section={section} style={style}/>
            </Suspense>
        )
    }

    private displaySection(){
        return this.state.datarow?.report?.map((d: any, i: number)=> {
            const style = d.option || (this.state.datarow.option[this.state.datarow.type] || Model.option[this.state.datarow.type])?.[d.type];
            const imagePosition = style?.image?.imagePosition || 0;
            
            if (this.state.datarowResult) d.content = AppService.replaceValue(d.content, this.state.datarowResult);
            this.isCompleted = i===this.state.datarow.reportLength-1;
            
            return (
                <Grid container key={i} width={1513} borderTop={i > 0? 10 : 0} borderColor='whitesmoke' pl={this.isMobile? 2: 20} pr={this.isMobile? 2: 20}>
                    <Grid id={this.htmlId} item container width={1513} sx={style?.frame}>
                        {imagePosition === 0 && 
                        <>
                        {d.imagetitle &&
                        <Grid item container sx={style?.imagetitle.frame}>
                            <Text label={d.imagetitle} bold sx={style?.imagetitle.typography} />
                        </Grid>
                        }
                        {d.image?.data &&
                        <Grid item container sx={style?.image}>
                            <Media url={ApiService.svrUrl + d.imageUrl} sx={{width: 'auto', height: style?.image?.imageHeight || this.isMobile? 100 : 200}} />
                        </Grid>
                        }
                        </>
                        }
                        <Grid item container sx={style?.title.frame}>
                            <Text label={d.title} bold sx={style?.title.typography} />
                        </Grid>
                        {imagePosition === 1 && 
                        <>
                        {d.imagetitle &&
                        <Grid item container sx={style?.imagetitle.frame}>
                            <Text label={d.imagetitle} bold sx={style?.imagetitle.typography} />
                        </Grid>
                        }
                        {d.image?.data &&
                        <Grid item container sx={style?.image}>
                            <Media url={ApiService.svrUrl + d.imageUrl} sx={{width: 'auto', height: style?.image?.imageHeight || this.isMobile? 100:200}} />
                        </Grid>
                        }
                        </>
                        }
                        <Grid item container sx={style?.content.frame}>
                            {d.content?.startsWith('<<') && d.content?.endsWith('>>')? 
                            this.getContent(d.content, style?.content.typography)
                            : 
                            <Text label={d.content} sx={style?.content.typography}/>
                            }    
                        </Grid>
                    </Grid>
                </Grid>
            )
        })
    }

    private onSave = async(data: any) => {
    }

    public componentDidUpdate = () => {
        if (this.state.isCompleted !== this.isCompleted && this.isReady)
            setTimeout(() =>  this.setState({isCompleted: this.isCompleted}), 500); 
    }

    render() {
        return (
            //editable..
            <BasePreview history={this.props.history} id={this.props.id} caption={this.props.disableView? ' ' : this.props.caption} buttonCaption={this.props.disableView || !this.state.isCompleted? ' ' : ''} proccessCaption={this.props.proccessCaption}
                endPointFilter={Model.endPointFilter2} model={Model} onLoad={this.onLoad} printOptions={this.state.datarow.option?.printOption} htmlId={this.htmlId} save={this.props.save && this.state.isCompleted} onLoadFile={this.props.onLoadFile} onSave={this.onSave} disableCard disableBackButton={this.props.disableView}>   
                <ScreenGuard disable={this.props.disableView}/>
                <Grid container bgcolor='white' height={this.props.disableView? 0 : 'auto'} width={this.props.disableView? 0 : 1513}>
                    {!this.isReady && this.state.datarow?.content?.startsWith('<<') && this.getContent(this.state.datarow.content)}
                    {this.displaySection()}
                </Grid>
            </BasePreview>
        );
    }
}